import React from 'react';

import { BrandLockup } from './BrandLockup';
import { ButtonLink } from '../../components/ButtonLink/ButtonLink';
import { useProductFavicon } from 'hooks/useFavicon';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import manuMascara from '../../assets/images/ConversasTerapeuticas/ultima-foto.jpg';
import 'styles/conversas-terapeuticas.css';
import './grupo-whatsapp.css';

const WHATSAPP_GROUP_LINK = 'https://chat.whatsapp.com/HGserulHbkoEYsHoa9Aykh?mode=gi_t';

export default function GrupoWhatsAppPage() {
  useProductFavicon(true);
  useDocumentTitle('O que a mulher de hoje quer e não sabe? · Conversas Terapêuticas');

  return (
    <div className="ct-page grupo-whatsapp-page">
      <section data-bg="#1f1016" className="poster-section closing-section dark-sec">
        <div className="closing-copy">
          <BrandLockup light />
          <h2 className="type-display">
            <span>O que a mulher</span>
            <span>de hoje quer e</span>
            <span>não sabe?</span>
          </h2>
          <p className="type-voice closing-subtitle">
            Uma noite aberta do Conversas Terapêuticas para pensar essa pergunta entre mulheres.
          </p>
          <p className="closing-meta closing-meta-date">03/09 · às 20h · no Zoom</p>
          <p className="closing-meta closing-meta-note">Entre no grupo pra receber o link da live!</p>
          <div className="closing-actions">
            <ButtonLink
              variant="solid"
              href={WHATSAPP_GROUP_LINK}
              target="_blank"
              rel="noopener noreferrer"
            >
              Entrar no grupo do WhatsApp
            </ButtonLink>
          </div>
        </div>
        <figure className="closing-photo">
          <img
            src={manuMascara}
            alt="Retrato de Manuela Xavier com o rosto parcialmente coberto"
            className="absolute inset-0 h-full w-full object-cover"
          />
        </figure>
      </section>
    </div>
  );
}
